export enum MatchOfferDeclineGroup {
    DonorUnacceptable           = 1,
    SurgeryDateUnacceptable     = 2,
    PatientDeactivated          = 3,
    IncludedInAll               = 4
}